import $ from "./jQuery-wrapper.js";
import CustomisedSmartPostShow from "./CustomisedSmartPostShow.js";

class Theme
{
	constructor(el)
	{
		this.$element = $(el);
		
		$("#pcp_wrapper-177, #pcp_wrapper-259, #pcp_wrapper-305").each((index, el) => {
			el.customisedSmartPostShow = new CustomisedSmartPostShow(el);
		});
	}
}

export default Theme;